'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'light-switch';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'e017';
var svgPathData = 'M48 48l0 416 288 0 0-416-288 0zM0 0L384 0 384 512 0 512 0 0zM144 368l96 0 0-88-96 0 0 88zm0-136l96 0 0-88-96 0 0 88zM96 96l192 0 0 320-192 0 0-320z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faLightSwitch = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;